import { dateUStoISO } from './date-converter';

let cloneDeep = require('lodash.clonedeep');

function fromLocaleString(str) {
	const num = Number(str.replace(/[\s,$]/g,''));
	return num === num ? num : null;
}

export default (query = {}, page = 'properties') => {
	const where = [];
	const param = {};
	const order = [];

    // NOTE: the order of these properties must match the order in the PROPERTIES query (/src/data/queries.sql)
    const propertyFilter = [
        id => match(id, 'name'),
        id => match(id, 'address'),
        id => multi(id, 'zip', 120),
        id => match(id, 'city'),
        id => multi(id, 'state', 100),
        id => exact(id, 'type'),
        id => multi(id, 'category', 5),
        id => exact(id, 'source'),
        id => exact(id, 'transaction_type'),
        id => multi(id, 'market', 9),
        id => exact(id, 'single_tenant_subcategory'),
        id => exact(id, 'lease_type'),
        id => exact(id, 'multi_tenant_subcategory'),
        id => exact(id, 'listing_agent_4'),
        id => exact(id, 'listing_agent_4_firm'),
        id => exact(id, 'buyer_agent_4'),
        id => exact(id, 'buyer_agent_4_firm'),
        id => num(id, 'sqft_min'),
        id => num(id, 'sqft_max'),
        id => num(id, 'list_price_min'),
        id => num(id, 'list_price_max'),
        id => num(id, 'net_operating_income_min'),
        id => num(id, 'net_operating_income_max'),
        id => num(id, 'sold_price_min'),
        id => num(id, 'sold_price_max'),
        id => num(id, 'capitalization_rate_min'),
        id => num(id, 'capitalization_rate_max'),
        id => num(id, 'price_per_sqft_min'),
        id => num(id, 'price_per_sqft_max'),
        id => num(id, 'close_price_per_sqft_min'),
        id => num(id, 'close_price_per_sqft_max'),
        id => remaingTime(id, 'lease_expiration_date_min'),
        id => remaingTime(id, 'lease_expiration_date_max'),
        id => exact(id, 'buyer_company_state'),
        id => exact(id, 'seller_company_state'),
        id => multi(id, 'status', 8),
        id => multi(id, 'hsc_status', 4),
        id => exact(id, 'listing_agent_team'),
        id => date(id, 'close_of_escrow_min'),
        id => date(id, 'close_of_escrow_max'),
        id => num(id, 'close_cap_rate_min'),
        id => num(id, 'close_cap_rate_max'),
        id => date(id, 'listed_date_min'),
        id => date(id, 'listed_date_max'),
        id => num(id, 'occupancy_min'),
        id => num(id, 'occupancy_max'),
        id => num(id, 'year_built_min'),
        id => num(id, 'year_built_max'),
        id => date(id, 'date_created_min'),
        id => date(id, 'date_created_max'),
        id => exact(id, 'created_by'),
        id => date(id, 'last_modified_min'),
        id => date(id, 'last_modified_max'),
        id => exact(id, 'modified_by'),
        id => exact(id, 'strive_slider'),
        id => exact(id, 'featured'),
        id => exact(id, 'visible'),
        id => num(id, 'lot_size_min'),
        id => num(id, 'lot_size_max'),
        id => exact(id, 'agent_name'),
        id => num(id, 'units_min'),
        id => num(id, 'units_max'),
        id => date(id, 'loan_closing_date_min'),
        id => date(id, 'loan_closing_date_max'),
    ];

    // NOTE: the order of these properties must match the order in the PROPERTIES_BY_BUYER_STATE query
    // (/src/data/queries.sql)
    const buyerBreakdownFilter = cloneDeep(propertyFilter);
    buyerBreakdownFilter.push(
        id => date(id, 'base_min'),
        id => date(id, 'base_max'),
        id => date(id, 'comparison_min'),
        id => date(id, 'comparison_max'),
	);
    
    propertyFilter.push(    
        id => exact(id, 'empty')
    );

    // NOTE: the order of these properties must match the order in the TEXAS_TOTAL_TRANSACTIONS,
    // TEXAS_REGION_TRANSACTIONS, BUYERS_LOCATION_TOTAL, BUYERS_LOCATION queries (/src/data/queries.sql)
    const transactionBreakdownFilter = [
        id => exact(id, 'state'),
        id => exact(id, 'type'),
        id => exact(id, 'category'),
        id => exact(id, 'status'),
        id => num(id, 'transaction_year'),
        id => num(id, 'sold_price_min'),
        id => num(id, 'sold_price_max'),
        id => num(id, 'sqft_min'),
        id => num(id, 'sqft_max'),
    ];

    // NOTE: the order of these properties must match the order in the TEXAS_MARKET_TRANSACTIONS query
    // (/src/data/queries.sql)
    const marketTransactionBreakdownFilter = [
        id => exact(id, 'state'),
        id => exact(id, 'type'),
        id => exact(id, 'category'),
        id => exact(id, 'market'),
        id => exact(id, 'status'),
        id => date(id, 'base_min'),
        id => date(id, 'base_max'),
        id => date(id, 'comparison_min'),
        id => date(id, 'comparison_max'),
    ];

    const marketShareFilter = [
        id => exact(id, 'source'),
        id => exact(id, 'state'),
        id => exact(id, 'type'),
        id => exact(id, 'category'),
        id => exact(id, 'market'),
        id => exact(id, 'status'),
    ]

    // NOTE: the order of these properties must match the order in the AGENTS_LIST query (/src/data/queries.sql)
    const agentFilter = [
        id => match(id, 'FIRST_NAME'),
        id => match(id, 'LAST_NAME'),
        id => match(id, 'EMAIL'),
        id => match(id, 'PHONE'),
        id => match(id, 'CELL_PHONE'),
        id => exact(id, 'FIRM'),
    ];

    // NOTE: the order of these properties must match the order in the SELLERS_LIST query
    // (/src/data/queries.sql)
    const sellerFilter = [
        id => match(id, 'FIRST_NAME'),
        id => match(id, 'LAST_NAME'),
        id => match(id, 'EMAIL'),
        id => match(id, 'PHONE'),    
        id => exact(id, 'STATUS'),    
        id => exact(id, 'PROFILE'),
        id => match(id, 'NOTES'),
        id => match(id, 'COMPANY_NAME'),
        id => match(id, 'COMPANY_ADDRESS'),
        id => match(id, 'COMPANY_CITY'),
        id => exact(id, 'COMPANY_STATE'),
        id => match(id, 'COMPANY_ZIP'),
    ];

    // NOTE: the order of these properties must match the order in the BUYERS_LIST query
    // (/src/data/queries.sql)
    const buyerFilter = [
        id => match(id, 'FIRST_NAME'),
        id => match(id, 'LAST_NAME'),
        id => match(id, 'EMAIL'),
        id => match(id, 'PHONE'),
        id => exact(id, 'PROFILE'),
        id => multi(id, 'STATUS', 2),
        id => exact(id, 'SINGLE_TENANT_SUBCATEGORY'),
        id => exact(id, 'MULTI_TENANT_SUBCATEGORY'),
        id => exact(id, 'PRICE_MIN'),
        id => exact(id, 'PRICE_MAX'),
        id => exact(id, 'CAP_RATE_MIN'),
        id => exact(id, 'CAP_RATE_MAX'),
        id => exact(id, 'STRIVE_AGENT'),
        id => match(id, 'NOTES'),
        id => match(id, 'COMPANY_NAME'),
        id => match(id, 'COMPANY_ADDRESS'),
        id => match(id, 'COMPANY_CITY'),
        id => exact(id, 'COMPANY_STATE'),
        id => match(id, 'COMPANY_ZIP'),
        id => exact(id, 'PROFILE'),
    ];
    const investorFilter = [
        id => match(id, 'FIRST_NAME'),
        id => match(id, 'LAST_NAME'),
        id => match(id, 'EMAIL'),
        id => match(id, 'PHONE'),
        id => exact(id, 'PROFILE'),
        id => multi(id, 'STATUS', 2),
        id => exact(id, 'SINGLE_TENANT_SUBCATEGORY'),
        id => exact(id, 'MULTI_TENANT_SUBCATEGORY'),
        id => exact(id, 'PRICE_MIN'),
        id => exact(id, 'PRICE_MAX'),
        id => exact(id, 'CAP_RATE_MIN'),
        id => exact(id, 'CAP_RATE_MAX'),
        id => exact(id, 'STRIVE_AGENT'),
        id => match(id, 'NOTES'),
        id => match(id, 'COMPANY_NAME'),
        id => match(id, 'COMPANY_ADDRESS'),
        id => match(id, 'COMPANY_CITY'),
        id => exact(id, 'COMPANY_STATE'),
        id => match(id, 'COMPANY_ZIP'),
        id => exact(id, 'PROFILE'),
    ];
    // NOTE: the order of these properties must match the order in the FIRMS_LIST query (/src/data/queries.sql)
    const firmFilter = [
        id => match(id, 'NAME'),
        id => match(id, 'ADDRESS'),
        id => match(id, 'CITY'),
        id => exact(id, 'STATE'),
        id => match(id, 'ZIP'),
        id => match(id, 'PHONE'),
        id => exact(id, 'PARENT_FIRM'),
        id => match(id, 'WEBSITE'),
    ];

    // NOTE: the order in the TENANT_LIST query (/src/data/queries.sql)
    const tenantFilter = [
        id => match(id, 'NAME'),
    ];

    const userFilter = [
         id => match(id, 'username'),
        id => match(id,'CITY'),
        id => match(id,'STATE'),
        id => match(id, 'CONTACT_NAME'),
        id => match(id, 'CONTACT_PHONE'),
        id => match(id, 'CONTACT_EMAIL'),
    ]

    // NOTE: the order of these properties must match the order in the LENDER_LIST query (/src/data/queries.sql)
    const lenderFilter = [
        id => match(id, 'NAME'),
        id => match(id,'CITY'),
        id => match(id,'STATE'),
        id => match(id, 'CONTACT_NAME'),
        id => match(id, 'CONTACT_PHONE'),
        id => match(id, 'CONTACT_EMAIL'),

    ];

    const underwritingMTFilter = [
        id => exact(id, 'PROPERTY_ID'),
    ];

    // NOTE: the order in the STRIVE_FEES query (/src/data/queries.sql)
    const striveFeesFilter = [
        id => multi(id, 'SOURCE', 2),
        id => date(id, 'START_DATE'),
        id => date(id, 'END_DATE'),
        id => multi(id, 'TRANSACTION_TYPE', 5),   
        id => exact(id, 'CATEGORY'),
        id => exact(id, 'TYPE'),
        id => exact(id, 'SIDE'),
        id => multi(id, 'AGENT_ID', 4),
    ];

    const hscPipelineFeesFilter = [
        id => exact(id, 'STATUS'),
        id => exact(id, 'YEAR'),
    ];

    const pipelinePropertiesFilter = [
        id => exact(id, 'CLOSE_OF_ESCROW'),
        id => exact(id, 'LIST_PRICE'),
        id => exact(id, 'SOLD_PRICE'),
        id => multi(id, 'STATUS', 2),
        id => multi(id, 'TRANSACTION_TYPE', 3),
        id => exact(id, 'BUYER_AGENT_4_FIRM', 6),
    ];

    const pipelinePropertiesV2 = [
        id => exact(id, 'LIST_PRICE'),
        id => exact(id, 'SOLD_PRICE'),
        id => exact(id, 'STATUS', 1),
        id => exact(id, 'CLOSE_OF_ESCROW', 4),
        id => exact(id, 'BUYER_AGENT_4_FIRM', 5),
    ];

    // NOTE: the order of these properties must match the order in the AGENT_COMMISSION_PROCURED and AGENT_COMMISSION_PAID queries (/src/data/queries.sql)
    const agentCommissionFilter = [
        id => exact(id, 'YEAR'),
        id => exact(id, 'AGENT_ID'),
        id => exact(id, 'BUYER_AGENT_4_FIRM', 1),
    ];
    
    const agentCommissionBreakDownFilter = [
        id => exact(id, 'YEAR'),
    ];

    const agentCommissionOrder = [
        'CLOSE_OF_ESCROW',
        'ARCIMEDES_ROW_ID', // leave this as last item
    ];

    const propertyOrder = [
        'SOURCE',
        'STATUS',
        'HSC_STATUS',
        'VISIBLE',
        'FEATURED',
        'NAME',
        'ADDRESS',
        'CITY',
        'STATE',
        'ZIP',
        'LATITUDE',
        'LONGITUDE',
        'HIGHLIGHTS',
        'MEDIA_KIT',
        'TYPE',
        'SQFT',
        'LIST_PRICE',
        'NET_OPERATING_INCOME',
        'VACANCY',
        'CAPITALIZATION_RATE',
        'SOLD_PRICE',
        'DOWN_PAYMENT',
        'EFFECTIVE_DATE',
        'CLOSE_OF_ESCROW',
        'LISTED_DATE',
        'SELLER_FEE_PERCENTAGE',
        'LEASE_TYPE',
        'LEASE_COMMENCEMENT_DATE',
        'LEASE_EXPIRATION_DATE',
        'SELLER_ID',
        'BUYER_ID',
        'YEAR_BUILT',
        'VIDEO_URL',
        'CLOSE_CAP_RATE',
        'CLOSE_NOI',
        'CLOSE_PRICE_PER_SQFT',
        'PRICE_PER_SQFT',
        'LISTING_AGENT_1',
        'LISTING_AGENT_2',
        'LISTING_AGENT_3',
        'LISTING_AGENT_4',
        'LISTING_AGENT_4_FIRM',
        'BUYER_AGENT_1',
        'BUYER_AGENT_2',
        'BUYER_AGENT_3',
        'BUYER_AGENT_4',
        'BUYER_AGENT_4_FIRM',
        'SINGLE_TENANT_SUBCATEGORY',
        'MULTI_TENANT_SUBCATEGORY',
        'TENANT_ID',
        'MARKET',
        'RENT_PER_SQFT',
        'AGENT_1_LAST_NAME',
        'NEGOTIATION_PRICE',
        'NEGOTIATION_CAP_RATE',
        'CATEGORY',
        'SELLERS_LAST_NAME',
        'HSC_PRICE',
        'LOAN_AMOUNT',
        'LTV',
        'INTEREST_RATE',
        'AMORTIZATION',
        'TERM',
        'LENDER_NAME',
        'ARCIMEDES_ROW_ID', // leave this as last item
    ];

    const propertyHistoryOrder = [
        'DATE',
        'STATUS',
        'LISTING_AGENT_1_FIRST_NAME',
        'LISTING_AGENT_FIRM_NAME',
        'PRICE',
        'CAP_RATE',
        'NET_OPERATING_INCOME',
        'PRICE_PER_SQFT',
        'BASE_RENT',
        'RENT_PER_SQFT',
        'VACANCY',
        'BUYER_FIRST_NAME',
        'SELLER_FIRST_NAME',
        'ARCIMEDES_ROW_ID', // leave this as last item
    ];

    const buyerBreakdownOrder = [
        'TOTAL_PROPERTIES',
        'COMPANY_STATE',
        'ARCIMEDES_ROW_ID', // leave this as last item
    ];

    const defaultOrder = [
        'ARCIMEDES_ROW_ID', // leave this as last item
    ];

    const agentOrder = [
        'FIRST_NAME',
        'LAST_NAME',
        'EMAIL',
        'PHONE',
        'CELL_PHONE',
        'NAME',
        'ARCIMEDES_ROW_ID', // leave this as last item
    ];

    const sellerOrder = [
        'STATUS',
        'FIRST_NAME',
        'LAST_NAME',
        'EMAIL',
        'PHONE',
        'COMPANY_NAME',
        'ARCIMEDES_ROW_ID', // leave this as last item
    ];

    const buyerOrder = [
        'STATUS',
        'CATEGORY',
        'TYPE',
        'SINGLE_TENANT_SUBCATEGORY',
        'MULTI_TENANT_SUBCATEGORY',
        'MARKET',
        'PRICE_MIN',
        'PRICE_MAX',
        'CAP_RATE_MIN',
        'CAP_RATE_MAX',
        'FIRST_NAME',
        'LAST_NAME',
        'EMAIL',
        'PHONE',
        'COMPANY_NAME',
        'STRIVE_AGENT_LAST_NAME',
        'ARCIMEDES_ROW_ID', // leave this as last item
    ];
    const investorOrder = [
        'STATUS',
        'CATEGORY',
        'TYPE',
        'SINGLE_TENANT_SUBCATEGORY',
        'MULTI_TENANT_SUBCATEGORY',
        'MARKET',
        'PRICE_MIN',
        'PRICE_MAX',
        'CAP_RATE_MIN',
        'CAP_RATE_MAX',
        'FIRST_NAME',
        'LAST_NAME',
        'EMAIL',
        'PHONE',
        'COMPANY_NAME',
        'STRIVE_AGENT_LAST_NAME',
        'ARCIMEDES_ROW_ID', // leave this as last item
    ];

    const firmOrder = [
        'NAME',
        'ADDRESS',
        'CITY',
        'STATE',
        'PHONE',
        'WEBSITE',
        'ARCIMEDES_ROW_ID', // leave this as last item
    ];

    const tenantOrder = [
        'NAME',
        'ARCIMEDES_ROW_ID', // leave this as last item
    ];

    const userOrder = [
        'username',
        'CITY',
        'STATE',
        'CONTACT_NAME',
        'CONTACT_PHONE',
        'CONTACT_EMAIL',
        'ARCIMEDES_ROW_ID', // leave this as last item 
    ]

    const lenderOrder = [
        'NAME',
        'CITY',
        'STATE',
        'CONTACT_NAME',
        'CONTACT_PHONE',
        'CONTACT_EMAIL',
        'ARCIMEDES_ROW_ID', // leave this as last item
    ];

    const underwritingMTOrder = [
        'TENANT_ROW_ID',
        'RR_SUITE_CODE',
    ];

    const striveFeesOrder = [
        'CLOSE_OF_ESCROW',
        'ARCIMEDES_ROW_ID', // leave this as last item
    ];

    const hscPipelineFeesOrder = [
        'LOAN_CLOSING_DATE',
        'ARCIMEDES_ROW_ID', // leave this as last item
    ];
    const teamMemberOrder = [
        'IS_AGENT',
        'FIRST_NAME',               
        'PHONE',
        'CELL_PHONE',
        'STARTING_DATE',
        'YRS_AT_STRIVE',
        'BIRTH_DATE',
        'ON_PHONES',
        'IN_POOL', 
        'FIRST_LISTING',
        'FIRST_CLOSING',
        'ADDRESS',
        'CITY',
        'ZIP',
        'ARCIMEDES_ROW_ID', // leave this as last item
    ];
    const teamMemberFilter = [
        id => match(id, 'IS_AGENT'),
        id => date(id, 'STARTING_DATE_MIN'),
        id => date(id, 'STARTING_DATE_MAX'),
        id => exact(id, 'ARCIMEDES_ROW_ID')
    ];

    const territoryFilter = [
        id => exact(id, 'territory_listing_agent_team'),
        id => multi(id, 'type', 2),
        id => multi(id, 'category', 5),
        id => multi(id, 'product_type', 5),
        id => multi(id, 'territory_market', 11),
        id => multi(id, 'territory', 4),
        id => multi(id, 'status', 8),
        id => exact(id, 'transaction_type'),
        id => date(id, 'close_of_escrow_min'),
        id => date(id, 'close_of_escrow_max'),
        id => date(id, 'listed_date_min'),
        id => date(id, 'listed_date_max'),
    ];
    
	function match(id, key) {
		if (!query[key]) return;
		param[key] = `%${query[key]}%`;
		where.push(id);
	}

	function exact(id, key) {
		if (!query[key]) return;

		let val = query[key];
		if ((key === 'modified_by' || key === 'created_by') &&
			String(val).toLowerCase() === 'auto') {
			val = 'AUTO';
		}
		param[key] = val;
		where.push(id);
	}

	function num(id, key) {
		if (!query[key]) return;

		const num = fromLocaleString(query[key]);
		if (num !== null) {
			param[key] = num;
			where.push(id);
		}
	}

	function remaingTime(id, key) {
		if (!query[key]) return;

		const num = Number(query[key]);
		if (num === num) {
			const d = new Date();
			const years = Math.floor(num);
			const months = Math.floor(12 * (num - years));
			const days = Math.round(30 * ((12 * (num - years)) - months));
			d.setUTCFullYear(d.getUTCFullYear()+years);
			d.setUTCMonth(d.getUTCMonth()+months);
			d.setUTCDate(d.getUTCDate()+days);
			param[key] = d.toISOString().slice(0,10);
			where.push(id);
		}
	}

	function date(id, key) {
		if (!query[key]) return;

		const date = dateUStoISO(query[key]);
		if (date !== false) {
			param[key] = date;
			where.push(id);
		}
	}

	function multi(id, key, count = 5) {
		if (query[key]) {
			var items = query[key].split(',');
			for (var i = 0; i < count; i++) {
				param[key+`_${i+1}`] = items[i] || 'NOMATCH'; // garbage value that will fail match
			}
			where.push(id);
		}
	}

    let id = 1;
    let filter = [];
    let orderCols = [];
    switch (page) {
        case 'properties':
            orderCols = propertyOrder;
            filter = propertyFilter;
            break;
        case 'buyer-breakdown':
            orderCols = buyerBreakdownOrder;
            filter = buyerBreakdownFilter;
            break;
        case 'transaction-breakdown':
            orderCols = defaultOrder;
            filter = transactionBreakdownFilter;
            break;
        case 'market-transaction-breakdown':
            orderCols = defaultOrder;
            filter = marketTransactionBreakdownFilter;
            break;
        case 'market-share':
            orderCols = defaultOrder;
            filter = marketShareFilter;
            break;
        case 'sellers':
            orderCols = sellerOrder;
            filter = sellerFilter;
            break;
        case 'buyers':
            orderCols = buyerOrder;
            filter = buyerFilter;
            break;
        case 'investors':
            orderCols = investorOrder;
            filter = investorFilter;
            break;
        case 'agents':
            orderCols = agentOrder;
            filter = agentFilter;
            break;
        case 'firms':
            orderCols = firmOrder;
            filter = firmFilter;
            break;
        case 'tenants':
            orderCols = tenantOrder;
            filter = tenantFilter;
            break;
        case 'lenders':
            orderCols = lenderOrder;
            filter = lenderFilter;
            break;
        case 'statistics':
            orderCols = defaultOrder;
            break;
        case 'underwritingMT':
            orderCols = underwritingMTOrder;
            filter = underwritingMTFilter;
            break;
        case 'striveFees':
            orderCols = striveFeesOrder;
            filter = striveFeesFilter;
            break;
        case 'hscPipeline':
            orderCols = [];
            filter = [];
            break;
        case 'hscPipelineFees':
            orderCols = hscPipelineFeesOrder;
            filter = hscPipelineFeesFilter;
            break;
        case 'history':
            orderCols = propertyHistoryOrder;
            break;
        case 'strivePipelineByStatus':
            orderCols = [];
            filter = pipelinePropertiesFilter;
            break;
        case 'strivePipeline':
        case 'strivePipelineSplit':
            orderCols = [];
            filter = pipelinePropertiesV2;
            break;
        case 'agent-commission':
            orderCols = agentCommissionOrder;
            filter = agentCommissionFilter;
            break;
        case 'agent-commission-break-down':
            orderCols = agentCommissionOrder;
            filter = agentCommissionBreakDownFilter;
            break;
        case 'team-member':
            orderCols = teamMemberOrder;
            filter = teamMemberFilter;
            break;
        case 'territories':
            orderCols = propertyOrder;
            filter = territoryFilter;
            break;
        case 'user':
            orderCols = userOrder;
            filter = userFilter;
            break;
    }

    filter.forEach((rule) => {
        // we need to take into account the first condition - it does not use any filter: (P.SOURCE = 'HSC' or P.HSC_FINANCING = 'y')
        if ((page.includes('hscPipeline') || page.includes('strivePipelineSplit')) && id === 1) {
            where.push('CW' + id);
            id++;
        }

        rule(`CW${id++}`);
    });
    if (['properties', 'buyer-breakdown'].includes(page)) {
        const tenants = (query.TENANT_ID || '').split(',');
        for (let i = 0; i < 15; i++) {
            if (tenants[i]) {
                param[`TENANT${i + 1}`] = tenants[i];
                param[`TENANT${i + 1}_FIRST`] = `${tenants[i]},%`;
                param[`TENANT${i + 1}_LAST`] = `%,${tenants[i]}`;
                param[`TENANT${i + 1}_MID`] = `%,${tenants[i]},%`;
                where.push('CW' + id);
            }
            id++;
        }

        if (query.CITY) {
            const cities = (query.CITY || '').split(',');
            for (let i = 0; i < 5; i++) {
                const city = cities[i] ? cities[i].replace(/^\s+|\s+$/g, '') : 'NOMATCH';
                param[`CITY_${i + 1}`] = city;
                param[`CITY_${i + 1}_FIRST`] = `${city}%`;
                param[`CITY_${i + 1}_LAST`] = `%${city}`;
                param[`CITY_${i + 1}_MID`] = `%${city}%`;
            }
            // where.push('CW' + id);
            // id++;
        } else id++
    }

    if (page.includes('hscPipeline') || page === 'properties'){
        if(id === 1){ // only for HSC_PIPELINE query
            where.push('CW' + id);
            id++;
        }
        if(query.hsc_team_members){
            const hscAgents = (query.hsc_team_members || '').split(',');
            param[`hsc_team_member_first`] = hscAgents[0] ? hscAgents[0] : 'NOMATCH';
            param[`hsc_team_member_last`] = hscAgents[1] ? hscAgents[1] : 'NOMATCH';
            where.push('CW' + id);
        }
        id++;
    }

    if (page === 'statistics') {
        if (query.property_id) {
            param.property_id = query.property_id;
            param.property_id_first = `${query.property_id},%`;
            param.property_id_last = `%,${query.property_id}`;
            param.property_id_mid = `%,${query.property_id},%`;
            where.push('CW' + id);
        }
        id++;
    }

    if (page === 'buyers') {
        const categories = (query.CATEGORY || '').split(',');
        for (let i = 0; i < 4; i++) {
            if (categories[i]) {
                param[`CATEGORY_${i + 1}`] = categories[i];
                param[`CATEGORY_${i + 1}_FIRST`] = `${categories[i]},%`;
                param[`CATEGORY_${i + 1}_LAST`] = `%,${categories[i]}`;
                param[`CATEGORY_${i + 1}_MID`] = `%,${categories[i]},%`;
                where.push('CW' + id);
            }
            id++;
        }

        const types = (query.TYPE || '').split(',');
        for (let i = 0; i < 2; i++) {
            if (types[i]) {
                param[`TYPE_${i + 1}`] = types[i];
                param[`TYPE_${i + 1}_FIRST`] = `${types[i]},%`;
                param[`TYPE_${i + 1}_LAST`] = `%,${types[i]}`;
                param[`TYPE_${i + 1}_MID`] = `%,${types[i]},%`;
                where.push('CW' + id);
            }
            id++;
        }

        const markets = (query.MARKET || '').split(',');
        for (let i = 0; i < 2; i++) {
            if (markets[i]) {
                param[`MARKET_${i + 1}`] = markets[i];
                param[`MARKET_${i + 1}_FIRST`] = `${markets[i]},%`;
                param[`MARKET_${i + 1}_LAST`] = `%,${markets[i]}`;
                param[`MARKET_${i + 1}_MID`] = `%,${markets[i]},%`;
                where.push('CW' + id);
            }
            id++;
        }
    }

    if (page === 'strivePipeline') {
        where.push('CW5');
    }
    if (page === 'strivePipelineByStatus') {
        where.push('CW6');
    }
    if (page === 'agent-commission') {
        where.push('CW6');
    }
    if(page === 'agent-commission-break-down'){
        where[0]='CW3';
    }

	if (query.order) {
		const orders = Array.isArray(query.order) ? query.order : [query.order];

		orders.forEach(x => {
			const [code, direction] = x.split('.');

            orderCols.some((column, i)=> {
				if (column === code) {
					order.push('CO'+(i*2+(direction === 'asc' ? 1 : 2)));
					return true;
				}
			});
		});
	}
	if (page !== 'underwritingMT') {
        if (['properties', 'buyer-breakdown'].includes(page)) {
            order.push('CO' + (orderCols.length * 2));          // ARCIMEDES_ROW_ID descending
        } else {
            order.push('CO' + (orderCols.length * 2 - 1));      // ARCIMEDES_ROW_ID ascending
        }
    }
    if(page=="properties"){
        let index = where.findIndex((e) => e=='CW63')
        let index61 = where.findIndex((e) => e=='CW61')
        let index62 = where.findIndex((e) => e=='CW62')
        let index64 = where.findIndex((e)=> e=='CW64')  
        let index65 = where.findIndex((e)=> e=='CW65')  
        let index66 = where.findIndex((e)=> e=='CW66')  
        let index67 = where.findIndex((e)=> e=='CW67')  
        if(index>=0){
            where[index]='CW60';
        }
        if(index61>=0){    
          where[index61]="CW78";
        }
        if(index62>=0){
            where[index62]="CW79";
        }
        if(index64>=0){
            where[index64]="CW61";
        }
        if(index65>=0){
            where[index65]="CW62";
        }
        if(index66>=0){
            where[index66]="CW63";
        }
        if(index67>=0){
            where[index67]="CW64";
        }

    }
    if(page=="buyer-breakdown"){
        let index63 = where.findIndex((e) => e=='CW63')
        let index64 = where.findIndex((e) => e=='CW64')
        let index65 = where.findIndex((e) => e=='CW65')
        let index66 = where.findIndex((e) => e=='CW66')

        if(index63>=0){
            where[index63]='CW60';
        }
        if(index64>=0){
            where[index64]='CW61';
        }
        if(index65>=0){
            where[index65]='CW62';
        }
        if(index66>=0){
            where[index66]='CW63';
        }
    }

    if(page=="properties"){
        let index = where.findIndex((e) => e=='CW80')
        if(index>=0){
            where[index]='CW77';
        }        
    }
    if(page=="team-member"){
        let index1 = where.findIndex((e) => e=='CW1')
        let index2 = where.findIndex((e) => e=='CW2')
        let index3 = where.findIndex((e) => e=='CW3')
        let index4 = where.findIndex((e) => e=='CW4')
      
        if(index1>=0){
            where[index1]='CW2';
        }  
        if(index2>=0){
            where[index2]='CW3';
        }
        if(index3>=0){
            where[index3]='CW4';
        }  
        if(index4>=0){
            where[index4]='CW5';
        }     
    }
    if(page == 'strivePipelineByStatus'){
        return {
            param,
            filter: {
                where
            }
        };
    } else {
        return {
            param,
            filter: {
                where
            },
            order,
        };
    }
};